// This file is automatically compiled by esbuild, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/assets/javascript and only use these files to reference
// that code so it'll be compiled.
import "core-js";
import "regenerator-runtime/runtime";
import "./controllers";

if (!window._rails_loaded) {
  require("@rails/ujs").start();
}
require("turbolinks").start();
require("@rails/activestorage").start();
